<p>
  Auth! {{accountService.getUserLogin()}}
  <!-- <code>{{ (user | async)?.uid }}</code> -->
  <button routerLink="/login" *ngIf="showLoginButton">Log in</button>
  <button (click)="logout()" *ngIf="showLogoutButton">Log out</button>
</p>
